import { render, staticRenderFns } from "./chengduSettingDialog.vue?vue&type=template&id=4f873da2&"
import script from "./chengduSettingDialog.vue?vue&type=script&lang=ts&"
export * from "./chengduSettingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./chengduSettingDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports